// qq 客户端
// https://www.cnblogs.com/xuzhengzong/p/9243127.html
function isQQAPP() {
	const ua = navigator.userAgent;
	var isIosQQ = /iPad|iPhone|iPod/.test(ua) && !window.MSStream && /\sQQ/i.test(ua);
	var isAndroidQQ = /(Android)/i.test(ua) && /MQQBrowser/i.test(ua) && /\sQQ/i.test(ua.split('MQQBrowser'));
	return isIosQQ || isAndroidQQ;
}

const ua = navigator.userAgent;
let platform = {
	// 移动终端浏览器版本信息
	ios: /iPad|iPhone|iPod/.test(ua) && !window.MSStream, // ios终端
	android: /android/i.test(ua), // android
	winphone: /IEMobile/i.test(ua),
	weixin: /micromessenger/i.test(ua), // 微信 客户端
	alipay: /alipayclient/i.test(ua), // 支付宝 客户端
	// kuaiyin: /kuaiyin/i.test(ua), // 刷宝
	kuaiyin: window.bridge && window.bridge.getUserInfo ? true : false, // 刷宝
	weibo: /WeiBo/gi.test(ua), // 微博客户端
	qq: isQQAPP(), // qq 客户端
};
platform.mobile = platform.ios || platform.android || platform.winphone;
platform.pc = !platform.mobile;
if (platform.ios) {
	platform.platform = 'ios';
} else if (platform.android) {
	platform.platform = 'android';
} else if (platform.winphone) {
	platform.platform = 'winphone';
} else {
	platform.platform = 'pc';
}

// 支付宝
export function AlipayReady(callback) {
	if (window.AlipayJSBridge) {
		callback && callback();
	} else {
		document.addEventListener('AlipayJSBridgeReady', callback, false);
	}
}

export default platform;



// WEBPACK FOOTER //
// ./src/lib/platform.js